import { cn } from '@src/lib/utils';

import { LayoutBuilderTypeFull, ServiceVM } from '@shared/types/process';

import { useLayoutViewContext } from '../LayoutViewContext';
import { BlockViewTab } from './BlockView/BlockViewTab';
import { LayoutBloc } from './LayoutBloc';

import { memo } from 'react';

const ChildLayout = ({
    childrenBlocks,
    flowTabType,
    isReadOnly,
    tabProps,
    service,
    classNameWrapper,
}: {
    childrenBlocks: LayoutBuilderTypeFull[];
    flowTabType?: React.ComponentPropsWithoutRef<
        typeof BlockViewTab
    >['flowTabType'];
    isReadOnly?: boolean;
    tabProps?: React.ComponentPropsWithoutRef<typeof BlockViewTab>['tabProps'];
    service?: ServiceVM;
    classNameWrapper?: string;
}) => {
    const context: ReturnType<typeof useLayoutViewContext> | null =
        useLayoutViewContext();

    return (
        <div
            className={cn(
                'grid grid-cols-3 gap-y-[16px]',
                classNameWrapper && 'gap-x-3',
                classNameWrapper,
            )}
        >
            {childrenBlocks.map((block) => (
                <div
                    key={block.id}
                    className='empty:hidden'
                    style={{
                        ...(context?.mainLayoutVariant !== 'readOnly'
                            ? {
                                  gridColumn: 'span ' + block.coordinates.w,
                                  gridColumnStart: block.coordinates.x + 1,
                                  gridColumnEnd:
                                      block.coordinates.x +
                                      block.coordinates.w +
                                      1,
                              }
                            : {
                                  gridColumn: '1 / -1',
                              }),
                    }}
                >
                    <LayoutBloc
                        block={block}
                        classNameWrapper={classNameWrapper}
                        flowTabType={flowTabType}
                        isReadOnly={isReadOnly}
                        service={service}
                        tabProps={tabProps}
                    />
                </div>
            ))}
        </div>
    );
};

export default memo(ChildLayout);
